import { render, staticRenderFns } from "./ContractsForm.vue?vue&type=template&id=22b8436a&scoped=true"
import script from "./ContractsForm.vue?vue&type=script&lang=js"
export * from "./ContractsForm.vue?vue&type=script&lang=js"
import style0 from "./ContractsForm.vue?vue&type=style&index=0&id=22b8436a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8436a",
  null
  
)

export default component.exports